import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { IS_DEVELOPMENT } from '@/configs';
import { initializeSentry } from '@/services/sentry';
import { initPostHog } from '@/services/posthog';
import { captureFirstTouchAttribution } from '@/lib/attribution';

// Chromium can emit this benign notification when a ResizeObserver callback
// causes another layout pass. Prevent preview/runtime overlays from treating
// it as an application crash; genuine ResizeObserver errors still surface.
window.addEventListener(
  'error',
  (event) => {
    if (
      event.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      event.message === 'ResizeObserver loop limit exceeded'
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true,
);


const shouldEnableSentry = !IS_DEVELOPMENT; // modify this to enable Sentry in other environments
console.log("Should initialize Sentry?", shouldEnableSentry);
if (shouldEnableSentry) {
  initializeSentry();
}

// First-touch attribution: snapshot UTMs/click IDs/referrer on initial load.
// No-op if a snapshot already exists (sticky first-touch).
captureFirstTouchAttribution();

// PostHog must init before React mounts: child effects (usePageTracking's
// first $pageview) run before parent effects, so an effect-driven init
// drops the landing pageview. No-op when VITE_POSTHOG_KEY is unset.
initPostHog();

createRoot(document.getElementById("root")!).render(<App />);
